export default __webpack_public_path__ + "static/media/0000..0006.051733d9.png";